import React from "react";

const FieldGroup = (props) => {
    const { children, className } = props;
    return <div className={`Field-group ${className ? className : ""}`}>{children}</div>;
};
export default FieldGroup;
